import { render, staticRenderFns } from "./CollegeDepartment.vue?vue&type=template&id=a8862b38"
import script from "./CollegeDepartment.vue?vue&type=script&lang=js"
export * from "./CollegeDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports